import { fetchTermsContents } from '@/api/api.terms';
import { ApiError } from '@/api/error/api.errors';
import { TermsCategory, TermsContentsResponse } from '@/api/terms.types';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

const useTermsContentsQuery = (
  category: TermsCategory,
  enabled: boolean = false,
): UseQueryResult<TermsContentsResponse, ApiError> => {
  return useQuery({
    staleTime: Infinity,
    gcTime: Infinity,
    enabled,
    queryKey: getQueryKey(category),
    queryFn: () => fetchTermsContents(category),
  });
};

const getQueryKey = (category: TermsCategory) => ['terms-contents', category];
useTermsContentsQuery.getQueryKey = getQueryKey;

export default useTermsContentsQuery;
